__turbopack_context__.v({
  "actions": "CartDrawer-module__tlybHq__actions",
  "content": "CartDrawer-module__tlybHq__content",
  "drawer": "CartDrawer-module__tlybHq__drawer",
  "header": "CartDrawer-module__tlybHq__header",
  "imgWrap": "CartDrawer-module__tlybHq__imgWrap",
  "productImg": "CartDrawer-module__tlybHq__productImg",
});
